import React, {useEffect, useState} from "react";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {useParams} from "react-router-dom";
import PostprocessorsService from "../../../API/details/organization/PostprocessorsService";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Button, Checkbox, DialogActions, FormControlLabel} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {PostprocessorSettingFields} from "../../../data/PostprocessorSettingFields";
import CircularProgress from "@mui/material/CircularProgress";
import FieldWithButtonAndChips from "../../../components/UI/textfield/FieldWithButtonAndChips";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";

const SettingsPostprocessors = () => {
    const [data, setData] = useState(null)
    const [newData, setNewData] = useState(null)
    const [change, setChange] = useState(false);
    const [alertData, setAlertData] = useState({});
    const params = useParams();
    const {id} = params
    const [tab, setTab] = useState(2);
    const [isLoading, setIsLoading] = useState(true);

    const handleChange = (event, newTab) => {
        setTab(newTab);
        EditLocalStoragePagesData("settings/postprocessor", "tab", newTab)
    };
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const tab = pagesData["settings/postprocessor"]?.tab
        setTab(tab || 2);
    }
    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    useEffect(() => {
        getStartPageSize()
        PostprocessorsService.getById(id).then(function (response) {
            setData(response.data);
            setNewData(response.data)
        })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setIsLoading(false))

    }, []);

    const handleUpdate = (updateData, drilling) => {
        const {id, machine, ...values} = updateData
        PostprocessorsService.update(values, id)
            .then(function (response) {
                setData(response.data)
                if (drilling) {
                    setNewData(response.data)
                    setChange(false)
                }
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }
    const handleEditDrilling = (value) => {
        setNewData(value)
        setChange(true)
    }
    const handleReset = () => {
        setNewData(data)
        setChange(false)
    }

    const renderContent = () => {
        switch (tab) {
            case 1:
                return <Box></Box>
            case 2:
                return <Box sx={{
                    display: "flex", flexDirection: "column", padding: "20px", gap: "20px", width: "1000px"
                }}>{
                    ["drillingBackDiameters",
                        "drillingBottomDiameters",
                        "drillingFrontDiameters",
                        "drillingLeftDiameters",
                        "drillingRightDiameters",
                        "drillingTopDiameters"
                    ].map(el => {
                        return <FieldWithButtonAndChips
                            key={el}
                            name={el}
                            label={PostprocessorSettingFields[el]}
                            value={newData[el]}
                            setCurrValues={handleEditDrilling}
                        />
                    })
                }
                    {change && <Box sx={{display: "flex", justifyContent: "end"}}>
                        <ButtonExit text={"Отменить"}
                                    onClick={handleReset}
                        />
                        <ButtonAdd text={"Сохранить"}
                                   onClick={() => handleUpdate(newData, true)}
                        />
                    </Box>}
                </Box>
            case 3:
                return <Box sx={{display: "flex", flexDirection: "column", padding: "20px",}}>{
                    ["millingBottomGroove", "millingBottomNotch", "millingDetailContour", "millingInnerContour", "millingTopGroove", "millingTopNotch"].map(el => {
                        return <FormControlLabel key={el} control={<Checkbox
                            checked={data[el] === true}
                            onChange={() => handleUpdate({...data, [el]: !data[el]})}
                        />} label={PostprocessorSettingFields[el]}/>
                    })
                }</Box>
            case 4:
                return <Box sx={{display: "flex", flexDirection: "column", padding: "20px",}}>{
                    ["cuttingBottomLongitudinalGroove", "cuttingBottomTransverseGroove", "cuttingTopLongitudinalGroove", "cuttingTopTransverseGroove"].map(el => {
                        return <FormControlLabel key={el} control={<Checkbox
                            checked={data[el] === true}
                            onChange={() => handleUpdate({...data, [el]: !data[el]})}
                        />} label={PostprocessorSettingFields[el]}/>
                    })
                }</Box>
        }
    }
    return isLoading ?
        <Box sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CircularProgress disableShrink/>
        </Box> : <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Настройки постпроцессора ${data?.name}`}
                path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>{`Настройки постпроцессора ${data?.name}`}</Typography>
            <Typography sx={{fontSize: "20px", paddingBottom: "32px"}}>{`Станок ${data?.machine.name}`}</Typography>
            <ModalAlert data={alertData} onClose={handleCloseAlert}/>
            <ButtonGroupTabBar activeTab={tab}>
                <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                    <CheckIcon/>
                    Общие
                </Button>
                <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                    <CheckIcon/>
                    Сверление
                </Button>
                <Button tabIndex={3} onClick={(e) => handleChange(e, 3)}>
                    <CheckIcon/>
                    Фрезерование
                </Button>
                <Button tabIndex={4} onClick={(e) => handleChange(e, 4)}>
                    <CheckIcon/>
                    Паз
                </Button>
            </ButtonGroupTabBar>
            {data !== null && renderContent()}
            <ModalAlert data={alertData} onClose={handleCloseAlert}/>
        </Box>
}
export default SettingsPostprocessors